import React, { createContext, useContext, useState } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ message: "", type: "" });

  const showToast = (message, type = "info") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Toast UI */}
      {toast.message && (
  <div
    className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-5 py-3 rounded-xl shadow-lg text-white font-medium transition-all duration-500 ${
      toast.type === "success"
        ? "bg-green-600"
        : toast.type === "error"
        ? "bg-red-600"
        : "bg-blue-600"
    }`}
  >
    {toast.message}
  </div>
)}

    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
